import type { TxSummary } from '@apm/contracts';
import { statusLevel } from '@apm/core';

/**
 * X-View 거르기 (19회차, 2026-09-07 결정 4 · 콘솔 검토 C-3).
 *
 * 두 가지뿐이다.
 *   - 실시간 연결(sse)은 **기본으로 뺀다.** 한 번 붙으면 수십 분 유지돼 세로축 위쪽에 줄로
 *     깔리고, 그 줄이 웹 요청 분포를 가린다. 보고 싶으면 켠다
 *   - 오류만 보기. 캔버스는 나중에 그린 점이 위에 오므로 정상 점이 많으면 오류 점이 묻힌다
 *
 * 컴포넌트 밖 순수 함수다. 프레임마다 수만 번 불리므로 안에서 객체를 만들지 않는다.
 */

export interface RowFilter {
  /** 전역에서 고른 서비스. 없으면 전체 */
  service?: string;
  /** 실시간 연결을 넣고 그릴지. 기본은 뺀다 */
  includeSse: boolean;
  /** 오류·실패만 그릴지 */
  errorsOnly: boolean;
}

export const DEFAULT_FILTER: RowFilter = { includeSse: false, errorsOnly: false };

export function matchesFilter(row: TxSummary, filter: RowFilter): boolean {
  if (filter.service !== undefined && row.service !== filter.service) return false;
  if (!filter.includeSse && row.txType === 'sse') return false;
  if (filter.errorsOnly && statusLevel(row) === 'ok') return false;
  return true;
}

/** 걸러 남는 건수. 화면이 "무엇을 빼고 세는지"를 말하려면 필요하다 */
export function countMatching(rows: readonly TxSummary[], filter: RowFilter): number {
  let count = 0;
  for (const row of rows) if (matchesFilter(row, filter)) count += 1;
  return count;
}
